import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Rows = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Rows({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 4C3 3.44772 3.44772 3 4 3H21C21.5523 3 22 3.44772 22 4V6C22 6.55228 21.5523 7 21 7H4C3.44771 7 3 6.55228 3 6V4ZM4.5 5.5V4.5H20.5V5.5H4.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 10C3.44772 10 3 10.4477 3 11V13C3 13.5523 3.44771 14 4 14H21C21.5523 14 22 13.5523 22 13V11C22 10.4477 21.5523 10 21 10H4ZM4.5 11.5V12.5H20.5V11.5H4.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 18C3 17.4477 3.44772 17 4 17H21C21.5523 17 22 17.4477 22 18V20C22 20.5523 21.5523 21 21 21H4C3.44771 21 3 20.5523 3 20V18ZM4.5 19.5V18.5H20.5V19.5H4.5Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'rows-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Rows;
